"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var react_highlight_words_1 = tslib_1.__importDefault(require("react-highlight-words"));
var core_1 = require("@material-ui/core");
var differenceBy_1 = tslib_1.__importDefault(require("lodash/fp/differenceBy"));
var unionBy_1 = tslib_1.__importDefault(require("lodash/fp/unionBy"));
var sortBy_1 = tslib_1.__importDefault(require("lodash/fp/sortBy"));
var Collapsible_1 = require("../../Components/Collapsible");
var ListTag_1 = require("../../Components/Tag/ListTag");
var PortfolioPickerCheckboxItem_1 = tslib_1.__importDefault(require("./PortfolioPickerCheckboxItem"));
var PortfolioGrouping = function (_a) {
    var grouping = _a.grouping, selectedPortfolios = _a.selectedPortfolios, setSelectedPortfolios = _a.setSelectedPortfolios, _b = _a.isTreeView, isTreeView = _b === void 0 ? false : _b, _c = _a.searchText, searchText = _c === void 0 ? '' : _c, _d = _a.showGroupName, showGroupName = _d === void 0 ? true : _d;
    var groupingID = grouping.ID, Name = grouping.Name, children = grouping.children;
    var isHighlighting = !!searchText && searchText.length > 1;
    var isDefaultGroup = Name === 'Default';
    var isGroupChecked = children.every(function (portfolio) {
        return selectedPortfolios.find(function (selectedPortfolio) { return selectedPortfolio.ID === portfolio.ID; });
    });
    var isGroupIndeterminate = !isGroupChecked &&
        children.some(function (portfolio) {
            return selectedPortfolios.find(function (selectedPortfolio) { return selectedPortfolio.ID === portfolio.ID; });
        });
    var updatePortfolioCheckboxStatus = function (checked, portfolio) {
        if (checked) {
            var updatedPortfolios = selectedPortfolios.filter(function (_a) {
                var ID = _a.ID;
                return ID !== portfolio.ID;
            });
            setSelectedPortfolios(updatedPortfolios);
        }
        else {
            setSelectedPortfolios(tslib_1.__spreadArrays(selectedPortfolios, [portfolio]));
        }
    };
    var updateGroupingCheckboxStatus = function () {
        if (isGroupChecked) {
            var portfolioList = differenceBy_1.default('ID', selectedPortfolios, children);
            setSelectedPortfolios(portfolioList);
        }
        else {
            var portfolioList = unionBy_1.default('ID', selectedPortfolios, children);
            setSelectedPortfolios(portfolioList);
        }
    };
    var highlightedName = isHighlighting ? (React.createElement(react_highlight_words_1.default, { autoEscape: true, searchWords: [searchText], textToHighlight: Name, highlightClassName: "option_highlighted_text" })) : (Name);
    var highlightedTag = isHighlighting ? (React.createElement(StyledHighlightedTag, { autoEscape: true, searchWords: [searchText], textToHighlight: "Default", highlightClassName: "option_highlighted_text", unhighlightClassName: "option_unhighlighted_text" })) : ('Default');
    var portfolios = sortBy_1.default('FullName', children).map(function (portfolio) {
        var portfolioID = portfolio.ID, FullName = portfolio.FullName, isDefault = portfolio.isDefault;
        var checked = selectedPortfolios.some(function (_a) {
            var ID = _a.ID;
            return ID === portfolioID;
        });
        var label = function () {
            return (React.createElement(React.Fragment, null,
                isHighlighting ? (React.createElement(react_highlight_words_1.default, { autoEscape: true, searchWords: [searchText], textToHighlight: FullName, highlightClassName: "option_highlighted_text" })) : (FullName),
                isDefault && (React.createElement(ListTag_1.ListTag, { "data-testid": "default-list-tag-" + portfolioID }, highlightedTag))));
        };
        return (React.createElement(StyledCheckboxListItem, { testID: "checkbox-item-" + portfolioID, key: portfolioID, checked: checked, onChange: function () { return updatePortfolioCheckboxStatus(checked, portfolio); }, label: label(), isTreeView: isTreeView }));
    });
    var generateCheckboxHeader = function () {
        return (React.createElement(StyledCheckboxHeaderContainer, null,
            React.createElement(StyledCheckboxHeader, { checked: isGroupChecked, indeterminate: isGroupIndeterminate, onChange: updateGroupingCheckboxStatus, label: highlightedName, isSelectAll: true })));
    };
    var generateGrouping = function () {
        if (isTreeView) {
            return (React.createElement(StyledCollapsibleDiv, null,
                React.createElement(Collapsible_1.Collapsible, { label: generateCheckboxHeader(), isOpen: true, isCheckboxLabel: true, expandMoreIcon: React.createElement("i", { className: "icon--chevron_right" }), expandLessIcon: React.createElement("i", { className: "icon--chevron_down" }), forceIsOpenPropOverwrite: isHighlighting },
                    React.createElement("div", null, portfolios))));
        }
        return (React.createElement(React.Fragment, null,
            showGroupName && React.createElement(StyledHeader, null, highlightedName),
            portfolios));
    };
    return (React.createElement(StyledContainer, { key: groupingID, isDefaultGroup: isDefaultGroup, isTreeView: isTreeView }, generateGrouping()));
};
exports.default = PortfolioGrouping;
var StyledContainer = styled_components_1.default(function (_a) {
    var isDefaultGroup = _a.isDefaultGroup, isTreeView = _a.isTreeView, rest = tslib_1.__rest(_a, ["isDefaultGroup", "isTreeView"]);
    return (React.createElement("div", tslib_1.__assign({}, rest)));
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding: 0rem;\n  padding-top: ", ";\n  // eslint-disable-next-line @typescript-eslint/no-unsafe-return\n\n  .iconContainer {\n    margin-top: 0rem;\n    align-self: center;\n  }\n"], ["\n  padding: 0rem;\n  padding-top: ",
    ";\n  // eslint-disable-next-line @typescript-eslint/no-unsafe-return\n\n  .iconContainer {\n    margin-top: 0rem;\n    align-self: center;\n  }\n"])), function (_a) {
    var isDefaultGroup = _a.isDefaultGroup, isTreeView = _a.isTreeView;
    if (isDefaultGroup && isTreeView) {
        return '0.5rem';
    }
    if (isDefaultGroup && !isTreeView) {
        return '0rem';
    }
    return '';
});
var StyledHeader = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: 500;\n  line-height: 1.6rem;\n  font-size: 1.3rem;\n  color: ", ";\n  margin-bottom: 0.9rem;\n  margin-left: 5rem;\n"], ["\n  font-family: ", ";\n  font-weight: 500;\n  line-height: 1.6rem;\n  font-size: 1.3rem;\n  color: ", ";\n  margin-bottom: 0.9rem;\n  margin-left: 5rem;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoMedium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[900];
});
var StyledCheckboxListItem = styled_components_1.default(function (_a) {
    var isTreeView = _a.isTreeView, rest = tslib_1.__rest(_a, ["isTreeView"]);
    return (React.createElement(PortfolioPickerCheckboxItem_1.default, tslib_1.__assign({}, rest)));
})(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  .root {\n    padding-left: ", ";\n  }\n  .option_highlighted_text {\n    background-color: ", ";\n  }\n"], ["\n  .root {\n    padding-left: ", ";\n  }\n  .option_highlighted_text {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var isTreeView = _a.isTreeView;
    return (isTreeView ? '7.5rem' : '');
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.yellow[400];
});
var StyledCollapsibleDiv = styled_components_1.default.div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  .collapsible-container {\n    padding: 0;\n  }\n"], ["\n  .collapsible-container {\n    padding: 0;\n  }\n"])));
var StyledCheckboxHeaderContainer = styled_components_1.default(core_1.ListItemSecondaryAction)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  && {\n    left: 5rem;\n    height: 3.2rem;\n  }\n"], ["\n  && {\n    left: 5rem;\n    height: 3.2rem;\n  }\n"])));
var StyledCheckboxHeader = styled_components_1.default(PortfolioPickerCheckboxItem_1.default)(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  .root {\n    padding: 0;\n\n    span {\n      font-family: ", " !important;\n      font-weight: 500;\n    }\n\n    .option_highlighted_text {\n      background-color: ", ";\n    }\n  }\n"], ["\n  .root {\n    padding: 0;\n\n    span {\n      font-family: ", " !important;\n      font-weight: 500;\n    }\n\n    .option_highlighted_text {\n      background-color: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoMedium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.yellow[400];
});
var StyledHighlightedTag = styled_components_1.default(react_highlight_words_1.default)(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  && {\n    padding: 0 !important;\n  }\n\n  && .option_highlighted_text,\n  .option_unhighlighted_text {\n    font-size: 0.9rem !important;\n    line-height: 1.5rem !important;\n    font-family: ", " !important;\n    padding: 0 !important;\n  }\n"], ["\n  && {\n    padding: 0 !important;\n  }\n\n  && .option_highlighted_text,\n  .option_unhighlighted_text {\n    font-size: 0.9rem !important;\n    line-height: 1.5rem !important;\n    font-family: ", " !important;\n    padding: 0 !important;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoMedium;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
